import { render, staticRenderFns } from "./VamosPaLaCalleRanking.vue?vue&type=template&id=db524a7a&scoped=true"
import script from "./VamosPaLaCalleRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleRanking.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VamosPaLaCalleRanking.vue?vue&type=style&index=0&id=db524a7a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db524a7a",
  null
  
)

export default component.exports